import { graphql } from "../../gql";

export const SWIPER_REPORT = graphql(`
  query SwiperReport($gameId: String!) {
    swiperReport(gameId: $gameId) {
      totalResponses
      attributeResults {
        attribute {
          id
          name
        }
        totalScore
      }
    }
  }
`);

export const RANKIFIER_REPORT = graphql(`
  query RankifierReport($gameId: String!) {
    rankifierReport(gameId: $gameId) {
      totalResponses
      attributeResults {
        attribute {
          id
          name
        }
        minuses
        pluses
        score
      }
    }
  }
`);

export const QUICKRANK_REPORT = graphql(`
  query QuickRankReport($gameId: String!) {
    quickRankReport(gameId: $gameId) {
      responseCount
      totalAttributes
      attributeResults {
        attribute {
          id
          name
        }
        avgRank
        avgRating
      }
    }
  }
`);

export const WORDOPOLIS_REPORT = graphql(`
  query WordopolisReport($gameId: String!) {
    wordopolisReport(gameId: $gameId) {
      totalResponses
      attributeResults {
        attribute {
          id
          name
        }
        avgScore
        avgRating
      }
    }
  }
`);

export const TRIVIA_REPORT = graphql(`
  query TriviaReport($gameId: String!) {
    triviaReport(gameId: $gameId) {
      questionResults {
        question {
          id
          question
        }
        scores {
          count
          option {
            text
            id
          }
        }
      }
      totalResponses
    }
  }
`);

export const GAME_RESPONSES = graphql(`
  query GameResponses($gameId: String!) {
    game(gameId: $gameId) {
      responses {
        id
      }
    }
  }
`);

export const TRIVIA_RESPONSE_REPORT = graphql(`
  query TriviaResponseReport($gameId: String!, $responseId: String!) {
    triviaResponseReport(gameId: $gameId, responseId: $responseId) {
      numberOfCorrectAnswers
      numberOfwrongAnswers
      scores {
        answer {
          id
          text
        }
        isCorrect
        question {
          id
          question
          options {
            id
            text
          }
        }
      }
    }
  }
`);

export const WORDLE_REPORT = graphql(`
  query WordleReport($gameId: String!) {
    wordleReport(gameId: $gameId) {
      totalResponses
      scoreResults {
        score
        count
      }
    }
  }
`);
